import { render } from "./ThemeSwitcher.vue?vue&type=template&id=40b6bbd2"
import script from "./ThemeSwitcher.vue?vue&type=script&lang=js"
export * from "./ThemeSwitcher.vue?vue&type=script&lang=js"

import exportComponent from "E:\\myproject\\vuejs-tailwindcss-portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__